/**
 * Returns a function that as long as it continues to be invoked, won't be triggered.
 * @param {Function} fn - Callback function.
 * @param {number} [wait=300] - Delay (in milliseconds).
 * @returns {Function}
 */
function debounce(fn, wait = 300) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('announcement-bar')) {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.nav = this.querySelector('.main-nav');
      this.overlay = document.querySelector('.js-overlay');
      this.overlayOpen = false;
      this.menu = document.querySelector('.main-menu__content');
      this.live_chat = document.querySelector('.live-chat-open');
      this.isPaused = false;
      this.firstLevelMenuLinks = this.querySelectorAll('.js-nav-hover');
      this.bindEvents();
      this.init();
    }

    disconnectedCallback() {
      if (this.moveLinksHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.moveLocalizationHandler) {
        window.removeEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }
    }

    bindEvents() {
      if (this.nav) {
        this.nav.addEventListener('click', AnnouncementBar.handleNavClick.bind(this))
      }
      if (this.live_chat) {
        this.live_chat.addEventListener('click', AnnouncementBar.handleChatClick.bind(this))
      }

      if (this.links) {
        this.moveLinksHandler = this.moveLinksHandler || this.moveLinks.bind(this);
        window.addEventListener('on:breakpoint-change', this.moveLinksHandler);
      }

      if (this.localization) {
        this.moveLocalizationHandler = this.moveLocalizationHandler
          || debounce(this.moveLocalization.bind(this));
        window.addEventListener('on:breakpoint-change', this.moveLocalizationHandler);
      }

      if (this.slider) {
        this.slider.addEventListener('mouseenter', this.pauseSlider.bind(this));
        this.slider.addEventListener('mouseleave', this.resumeSlider.bind(this));
      }
    }

    /**
     * Start sliders a slidin'
     */
    init() {
      if (this.slider) {
        const slides = this.slider.querySelectorAll('.announcement__text');
        slides[0].classList.add('is-visible');

        const nextSlide = () => {
          if (!this.isPaused && theme.elementUtil.isInViewport(this)) {
            const currSlide = this.slider.querySelector('.announcement__text.is-visible');
            const currSlideIndex = Array.from(currSlide.parentNode.children)
              .indexOf(currSlide);
            const nextSlideIndex = currSlideIndex + 1 < slides.length ? currSlideIndex + 1 : 0;

            if (document.dir === 'rtl') {
              this.slider.scrollTo(
                -Math.abs(nextSlideIndex * slides[nextSlideIndex].clientWidth),
                0
              );
            } else {
              this.slider.scrollTo(slides[nextSlideIndex].offsetLeft - 32, 0);
            }

            slides[nextSlideIndex].classList.add('is-visible');
            slides[currSlideIndex].classList.remove('is-visible');
          }

          setTimeout(nextSlide, this.dataset.slideDelay);
        };
        setTimeout(nextSlide, this.dataset.slideDelay);
      }

      if (this.overlayOpen) this.toggleOverlay(false);

      if (theme.device.hasHover) {
        this.mouseEnterMenuLinkHandler = this.mouseEnterMenuLinkHandler  || this.handleMouseEnterMenuLink.bind(this);
        this.mouseLeaveMenuLinkHandler = this.mouseLeaveMenuLinkHandler  || this.handleMouseLeaveMenuLink.bind(this);
      }

      if (this.firstLevelMenuLinks) {
        this.firstLevelMenuLinks.forEach((menuLink) => {
          menuLink.addEventListener('mouseenter', this.mouseEnterMenuLinkHandler);
          menuLink.addEventListener('mouseleave', this.mouseLeaveMenuLinkHandler);
        });
      }

      // if (this.links) {
      //   this.moveLinks();
      // }

      if (this.localization) {
        this.moveLocalization();
      }
    }

    /**
     * Move the help links selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLinks() {
      const menuAnnouncementLinks = document.querySelector('.mob__announcement-links');
      if (!theme.mediaMatches.md && !menuAnnouncementLinks) {
        // Move localization to mobile
        const mobNav = document.createElement('nav');
        mobNav.classList.add('mob__announcement-links');

        const mobNavUl = document.createElement('ul');
        mobNav.classList.add('secondary-nav');

        this.links.forEach((link) => {
          mobNav.innerHTML += `<li><a class="secondary-nav__item" href="${link.href}">${link.innerText}</a>`;
        });

        mobNav.appendChild(mobNavUl);
        this.menu.appendChild(mobNav);
      } else if (theme.mediaMatches.md && menuAnnouncementLinks) {
        menuAnnouncementLinks.remove();
      }
    }

    /**
     * Move the localization selectors to the mobile nav/back to the announcement bar if necessary
     */
    moveLocalization() {
      this.slider = this.querySelector('.announcement__slider');
      this.localization = this.querySelector('.announcement__localization');
      this.links = this.querySelectorAll('.js-announcement-link');
      this.menu = document.querySelector('.main-menu__content');
      const menuLocalization = document.querySelector('.mob__localization');
      if (!theme.mediaMatches.md && !menuLocalization) {
        // Move localization to mobile
        const mobLocalizationElem = document.createElement('div');
        mobLocalizationElem.classList.add('mob__localization');
        mobLocalizationElem.appendChild(this.localization.firstElementChild);
        this.menu.appendChild(mobLocalizationElem);
      } else if (theme.mediaMatches.md && menuLocalization) {
        // Move localization back to announcement bar
        this.localization.appendChild(menuLocalization.firstElementChild);
        menuLocalization.remove();
      }
    }

    /**
     * Pauses the auto-rotating slider
     */
    pauseSlider() {
      this.isPaused = true;
    }

    /**
     * Resumes the auto-rotating slider
     */
    resumeSlider() {
      this.isPaused = false;
    }

    static handleChatClick(evt){
      
      if (document.querySelector('.intercom-launcher')) {
          document.querySelector('.intercom-launcher').click()
      } else if (document.querySelector(".intercom-launcher-frame")) {
        const intercom_frame = document.querySelector(".intercom-launcher-frame");
        if (intercom_frame.contentWindow.document.querySelector(".intercom-launcher")) {
          intercom_frame.contentWindow.document.querySelector(".intercom-launcher").click();
        }
      }
    }

    static handleNavClick(evt) {
      let el = evt.target;
      if (evt.target.href && evt.target.href.endsWith('#')) evt.preventDefault();

      if (theme.mediaMatches.md && !theme.device.hasHover) {
        el = evt.target.closest('.js-toggle');
        if (!el) return;
      }

      const disclosure = el.closest('details');
      
      if (theme.mediaMatches.md && theme.device.hasTouch) {
        if (disclosure.classList.contains("is-open")) {
          if (evt.target.querySelector("a")) {
            window.location.href = evt.target.querySelector("a").getAttribute("href");
          } else {
            this.toggleOverlay(false);
            this.close(disclosure, true)
          }
        } else {
          this.handleMouseEnterMenuLink(evt)
        }
        return;
      }
    }


    handleMouseEnterMenuLink(evt) {
      this.menuLinkTimeout = setTimeout(
        this.openMenuFromMouseEnter.bind(this, evt.target),
        Number.parseInt(this.dataset.menuSensitivity, 10)
      );
    }

    handleMouseLeaveMenuLink() {
      if (this.menuLinkTimeout) clearTimeout(this.menuLinkTimeout);
    }

    openMenuFromMouseEnter(menuElem) {
      trapFocus(menuElem);
      
      const disclosure = menuElem.closest('details');
      if (!disclosure.classList.contains('is-open')) {
        const activeDisclosure = this.nav.querySelector('details.is-open');

        // If there's another menu open, close it.
        if (activeDisclosure && activeDisclosure !== disclosure) {
          this.close(activeDisclosure);
        } else {
          this.toggleOverlay(!this.overlayOpen);
        }

        MainMenu.open(disclosure);
      }
    }

    toggleOverlay(show) {
      this.overlayOpen = show;
      this.overlay.classList.toggle('overlay--nav', show);
      this.overlay.classList.toggle('is-visible', show);

      if (show) {
        // Add event handler (so the bound event listener can be removed).
        this.closeHandler = this.closeHandler || this.handleClose.bind(this);

        // Add event listeners (for while the nav is open).
        this.overlay.addEventListener('click', this.closeHandler);
        this.nav.addEventListener('keyup', this.closeHandler);

        if (theme.mediaMatches.md) {
          this.overlay.addEventListener('mouseenter', this.closeHandler);
        }
      } else {
        // Remove event listener added on nav opening.
        this.overlay.removeEventListener('click', this.closeHandler);
        this.nav.removeEventListener('keyup', this.closeHandler);

        if (theme.mediaMatches.md) {
          this.overlay.removeEventListener('mouseenter', this.closeHandler);
        }
      }
    }

    handleClose(evt) {
      if (evt && evt.type === 'keyup' && evt.key !== 'Escape') return;

      const disclosure = theme.mediaMatches.md
        ? this.nav.querySelector('details.is-open')
        : this.mainDisclosure;

      if (disclosure) {
        this.close(disclosure, true);
        this.toggleOverlay(false);
        this.childNavOpen = false;
      }
    }

    close(el, transition = true) {
      el.classList.remove('is-open');
      
      if (transition) {
        el.classList.add('is-closing');
      } else {
        el.classList.remove('is-closing');
        el.open = false;

        removeTrapFocus(this.opener);
        this.opener = null;
      }

      setTimeout(() => {
        const offsetMenu = el.querySelector('.main-nav__child--offset-right');
        if (offsetMenu) offsetMenu.classList.remove('main-nav__child--offset-right');
      }, 200);

      if (theme.mediaMatches.md || el.classList.contains('main-menu__disclosure')) {
        document.body.classList.remove('overflow-hidden', 'fixed');
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
}
